<template>
  <v-select
    :value="value"
    :items="types"
    v-bind="$props"
    dense
    single-line
    hide-details
    hide-selected
    item-value="id"
    item-text="description"
    @change="updateLeadType"
    :loading="loading"
    :disabled="loading"
  ></v-select>
</template>

<script>
export default {
  props: ["label", "value", "lead_id", "dark", "light", "solo", "flat"],
  name: "select-lead-types",
  data: () => ({
    loading: false
  }),
  methods: {
    async updateLeadType(value) {
      this.loading = true;
      try {
        await this.$http.put("/leads/" + this.lead_id, {
          lead_type: value
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    types: function() {
      return this.$store.getters["lead_types/getLeadTypes"];
    }
  }
};
</script>
